/**
 * Created by RUSS_ on 07.05.2018
 *
 * Note: don't change id's of cookies because these are used as keys
 */

export default {
  generate: () => {
    const config = {
      necessary: {
        name: `${myTranslation("necessary")} Cookies`,
        description: myTranslation("necessary_desc"),
        list: [
          {
            id: "russcity_necessary",
            name: "RuSsCiTy",
            description:
              "The personal site of Ruslan Ragimov. This cookies may store your settings about cookies",
            usage: {
              en:
                "The personal site of Ruslan Ragimov. This cookies may store your settings about cookies.",
              de:
                "Die persönliche Seite von Ruslan Ragimov. Diese Cookies können Ihre Einstellungen zu Cookies speichern.",
              ru:
                "Персональный сайт Руслана Рагимова. Эти файлы cookie могут сохранять ваши настройки в отношении файлов cookie."
            },
            domains: ["russ.city", "russcity.de"],
            privacy: "https://alltracker.org/index.jsp?page=privacy",
            terms: "https://alltracker.org/index.jsp?page=lizens_agree",
            accepted: true,
            immutable: true
          },
          {
            id: "alltracker_necessary",
            name: "AllTracker",
            description:
              "Best way to monitor your Android device. Protect Yourself and Your Family! This cookies stores your personal preferences, manages your secure login to the web page.",
            usage: {
              en:
                "Best way to monitor your Android device. Protect Yourself and Your Family! This cookies stores your personal preferences, manages your secure login to the web page.",
              de:
                "Beste Möglichkeit, Ihr Android-Gerät zu überwachen. Beschütze dich und deine Familie! Dieser Cookie speichert Ihre persönlichen Einstellungen und verwaltet Ihre sichere Anmeldung auf der Webseite.",
              ru:
                "Лучший способ контролировать ваше Android-устройство. Защитите себя и свою семью! Это файлы Cookie сохраняют ваши личные предпочтения, управляет вашим безопасным входом на веб-страницу."
            },
            domains: ["alltracker.org", "alltracker.de", "alltracker.su"],
            privacy: "https://alltracker.org/index.jsp?page=privacy",
            terms: "https://alltracker.org/index.jsp?page=lizens_agree",
            accepted: true,
            immutable: true
          }
        ]
      },
      preferences: {
        name: `${myTranslation("preferences")} Cookies`,
        description: myTranslation("preferences_desc"),
        list: [
          {
            id: "facebook_like",
            name: "Facebook Like",
            description:
              "Facebook is an American online social media and social networking service company based in Menlo Park, California. This cookie makes it possible to share your experience with the world by Facebook!",
            usage: {
              en:
                "Facebook is an American online social media and social networking service company based in Menlo Park, California. This cookie makes it possible to share your experience with the world by Facebook!",
              de:
                "Facebook ist ein amerikanisches Online-Social-Media- und Social-Networking-Unternehmen mit Sitz in Menlo Park, Kalifornien. Dieser Cookie ermöglicht es, Ihre Erfahrungen mit der Welt über Facebook zu teilen!",
              ru:
                "Facebook - американская социальная сеть, основанная в Менло-Парке, штат Калифорния. Этот Cookie-файл позволяет поделиться своим опытом с миром через Facebook!"
            },
            domains: ["facebook.com"],
            privacy: "https://www.facebook.com/legal/FB_Work_Privacy",
            terms: "https://www.facebook.com/terms.php",
            accepted: false,
            immutable: false
          },
          {
            id: "vk_com",
            name: "VK.com",
            description:
              "VK is a Russian online social media and social networking service. It is available in several languages but it is especially popular among Russian-speaking users. This cookie makes it possible to share your experience with the world by VK!",
            usage: {
              en:
                "VK is a Russian online social media and social networking service. It is available in several languages but it is especially popular among Russian-speaking users. This cookie makes it possible to share your experience with the world by VK!",
              de:
                "VK ist ein russischer Online-Social-Media- und Social-Networking-Service. Es ist in mehreren Sprachen verfügbar, ist aber besonders bei russischsprachigen Benutzern beliebt. Dieser Cookie ermöglicht es, Ihre Erfahrungen mit der Welt über VK zu teilen!",
              ru:
                "VK - это русская онлайн-социальная сеть. Она доступена на нескольких языках, но особенно популярена среди русскоязычных пользователей. Этот Cookie-файл позволяет поделиться своим опытом с миром через VK!"
            },
            domains: ["vk.com", "vk.ru"],
            privacy: "https://vk.com/privacy/",
            terms: "https://vk.com/terms/",
            accepted: false,
            immutable: false
          }
        ]
      },
      statistics: {
        name: `${myTranslation("statistics")} Cookies`,
        description: myTranslation("statistics_desc"),
        list: [
          {
            id: "google_analytics",
            name: "Google Analytics",
            description:
              "Google (www.google.com) operates the Google Display Network a collection of millions of websites and mobile applications that are powered by display advertising, including many Google services like YouTube. Analytics cookies are used to collect some useful statistics about user experience on our web page.",
            usage: {
              en:
                "Google (www.google.com) operates the Google Display Network a collection of millions of websites and mobile applications that are powered by display advertising, including many Google services like YouTube. Analytics cookies are used to collect some useful statistics about user experience on our web page.",
              de:
                "Google (www.google.com) betreibt das Google Display-Netzwerk eine Sammlung von Millionen von Websites und mobilen Anwendungen, die auf Display-Werbung basieren, darunter viele Google-Dienste wie YouTube. Analytics-Cookies werden verwendet, um einige nützliche Statistiken über die Nutzererfahrung auf unserer Webseite zu sammeln.",
              ru:
                "Google (www.google.com) управляет контекстно-медийной сетью Google, собрав миллионы веб-сайтов и мобильных приложений, которые работают на медийной рекламе, включая многие сервисы Google, такие как YouTube. Файлы cookie от Google Analytics используются для сбора полезной статистики о пользовательском опыте на нашей веб-странице."
            },
            domains: ["google.com", "google.de"],
            privacy: "http://www.google.com/intl/en/policies/privacy/",
            terms: "https://www.google.com/intl/en/policies/terms/",
            accepted: false,
            immutable: false
          },
          {
            id: "yandex_metrica",
            name: "Yandex Metrica",
            description:
              "From traffic trends to mouse movements – Yandex helps to get a comprehensive understanding of online audience and drive business growth. Cookies of Yandex Metrica are used to collect some useful statistics about user experience on our web page.",
            usage: {
              en:
                "From traffic trends to mouse movements – Yandex helps to get a comprehensive understanding of online audience and drive business growth. Cookies of Yandex Metrica are used to collect some useful statistics about user experience on our web page.",
              de:
                "Von Verkehrstrends bis hin zu Mausbewegungen - Yandex hilft, ein umfassendes Verständnis der Online-Zielgruppe zu erlangen und das Geschäftswachstum anzukurbeln. Cookies von Yandex Metrica werden verwendet, um nützliche Statistiken über die Benutzererfahrung auf unserer Webseite zu sammeln.",
              ru:
                "От тенденций движения до движений мыши - Yandex помогает получить полное представление о онлайн-аудитории и стимулировать рост бизнеса. Cookie-файлы Yandex Metrica используются для сбора полезной статистики о пользовательском опыте на нашей веб-странице."
            },
            domains: ["yandex.ru", "metrica.yandex.ru", "mc.yandex.ru"],
            privacy: "https://metrica.yandex.com/about/info/privacy-policy/",
            terms: "https://yandex.com/legal/metrica_termsofuse/",
            accepted: false,
            immutable: false
          }
        ]
      },
      marketing: {
        name: `${myTranslation("marketing")} Cookies`,
        description: myTranslation("marketing_desc"),
        list: [
          {
            id: "google_adsense",
            name: "Google Adsense.",
            description:
              "Google AdSense is a program run by Google that allows publishers in the Google Network of content sites to serve automatic text, image, video, or interactive media advertisements, that are targeted to site content and audience.",
            usage: {
              en: "Google AdSense is a program run by Google that allows publishers in the Google Network of content sites to serve automatic text, image, video, or interactive media advertisements, that are targeted to site content and audience.",
              de: "Google AdSense ist ein von Google betriebenes Programm, mit dem Publisher im Google-Werbenetzwerk von Content-Websites automatische Text-, Bild-, Video- oder interaktive Medienanzeigen schalten können, die auf Website-Content und Zielgruppe ausgerichtet sind.",
              ru: "Google AdSense - это программа от Google, которая позволяет издателям в сети контекстно-медийной сети Google обслуживать автоматические текстовые, графические, видео или интерактивные медиа-рекламы, предназначенные для контента и аудитории сайта."
            },
            domains: [
              "google.de",
              "google.com",
              "google.de",
              "googlesyndication.com",
              "googleads.g.doubleclick.net",
              "tpc.googlesyndication.com"
            ],
            privacy: "https://policies.google.com/privacy",
            terms: "https://www.google.com/adsense/new/localized-terms",
            accepted: false,
            immutable: false
          },
          {
            id: "youtube",
            name: "Youtube",
            description:
              "Google (www.google.com) operates the Google Display Network a collection of millions of websites and mobile applications that are powered by display advertising, including many Google services like YouTube. Youtube cookies are used to get better experience on targeting ads to the user's interests based on the information that the cookie collected.",
            usage: {
              en: "Google (www.google.com) operates the Google Display Network a collection of millions of websites and mobile applications that are powered by display advertising, including many Google services like YouTube. Youtube cookies are used to get better experience on targeting ads to the user's interests based on the information that the cookie collected.",
              de: "Google (www.google.com) betreibt das Google Display-Netzwerk eine Sammlung von Millionen von Websites und mobilen Anwendungen, die auf Display-Werbung basieren, darunter viele Google-Dienste wie YouTube. Youtube-Cookies werden verwendet, um bessere Ergebnisse beim Targeting von Anzeigen auf die Interessen des Nutzers zu erzielen, basierend auf den Informationen, die der Cookie gesammelt hat.",
              ru: "Google (www.google.com) управляет контекстно-медийной сетью Google, собрав миллионы веб-сайтов и мобильных приложений, которые работают на медийной рекламе, включая многие сервисы Google, такие как YouTube. Cookie файды Youtube используются для получения лучшего опыта по таргетингу объявлений в интересах пользователя на основе информации, собранной cookie."
            },
            domains: ["www.youtube.com", "youtube.com"],
            privacy: "http://www.google.com/intl/en/policies/privacy/",
            terms: "https://www.google.com/intl/en/policies/terms/",
            accepted: false,
            immutable: false
          }
        ]
      }
    };
    return config;
  }
};



// WEBPACK FOOTER //
// ./src-cookie-manager/const/default-cookies-config.js